import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "u-kpi-picker-tags"
};
import { toRefs } from 'vue';
export default {
  __name: 'filter-tags',
  props: {
    search: {
      type: String,
      default: ''
    },
    industry: {
      type: String,
      default: ''
    },
    depItems: {
      type: Array,
      default: () => []
    }
  },
  emits: ['del-search', 'del-dep', 'del-industry'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const {
      search,
      industry,
      depItems
    } = toRefs(props);
    const handleDelSearch = () => {
      emit('del-search', search.value);
    };
    const handleDelIndustry = () => {
      emit('del-industry', industry.value);
    };
    const handleDelDep = (idx, item) => {
      emit('del-dep', idx, item);
    };
    return (_ctx, _cache) => {
      const _component_a_tag = _resolveComponent("a-tag");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(depItems), (dep, idx) => {
        return _openBlock(), _createBlock(_component_a_tag, {
          key: `idx_${idx}`,
          color: "blue",
          bordered: false,
          closable: "",
          onClose: () => handleDelDep(idx, dep)
        }, {
          default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(dep), 1)]),
          _: 2
        }, 1032, ["onClose"]);
      }), 128)), !!_unref(industry) ? (_openBlock(), _createBlock(_component_a_tag, {
        key: 0,
        color: "blue",
        bordered: false,
        closable: "",
        onClose: handleDelIndustry
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_unref(industry)), 1)]),
        _: 1
      })) : _createCommentVNode("", true), !!_unref(search) ? (_openBlock(), _createBlock(_component_a_tag, {
        key: 1,
        color: "blue",
        bordered: false,
        closable: "",
        onClose: handleDelSearch
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_unref(search)), 1)]),
        _: 1
      })) : _createCommentVNode("", true)]);
    };
  }
};